module.exports = __webpack_public_path__ + "img/landing_th.17e25245.jpg";